import { render } from "./Riepilogo.vue?vue&type=template&id=166f3be9"
import script from "./Riepilogo.vue?vue&type=script&lang=js"
export * from "./Riepilogo.vue?vue&type=script&lang=js"

import "./Riepilogo.vue?vue&type=style&index=0&id=166f3be9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__